import React from 'react';
import without from 'lodash/without';
import intersection from 'lodash/intersection';
import { withState, withStateHandlers, compose, lifecycle, withProps } from 'recompose';

export const withAccordion = (SubAccordion) => compose(
  withState('activeItems', 'setActiveItems',[]),
  withStateHandlers(
    { accordionCounter: 0 },
    {
      onRerender: ({ accordionCounter }) => () => ({ accordionCounter: accordionCounter + 1 })
    }
  ),
  lifecycle({
    componentDidMount() {
      const { defaultActiveItems, setActiveItems } = this.props;
      if(defaultActiveItems){
        setActiveItems(defaultActiveItems)
      }
    },
    componentWillReceiveProps(nextProps) {
      const { defaultActiveItems, setActiveItems } = nextProps;
      if(defaultActiveItems){
        if((
            intersection(this.props.defaultActiveItems, defaultActiveItems).length !==
            this.props.defaultActiveItems.length
          ) || (
            this.props.defaultActiveItems.length !== defaultActiveItems.length
          )
        ){
          setActiveItems(defaultActiveItems)
        }
      }
    }
  }),
  withProps(({ activeItems, setActiveItems, onRerender, onAccordionClick = () => {}, onTouchTab = () => {} }) => ({
    renderAccordion: (children, accordionProps) => {
      const Children = React.Children.toArray(children);
      const handleItemClick = (id) => {
        return setActiveItems(
          activeItems.indexOf(id) !== -1 ?
            // this item is in active, remove from activeItems
            without(activeItems, id)
            :
            activeItems.concat(id)
        );
      };
      return Children.map((child, i) => {
        const { props: { subValue, label, ...others } } = child;
        return (
          <SubAccordion
            key={i}
            {...accordionProps}
            label={label}
            isActive={activeItems.indexOf(subValue) !== -1}
            onTouchTap={
              () => {
                onTouchTab(subValue);
                handleItemClick(subValue)
                return setTimeout(onAccordionClick, 170)
              }
            }
            {...others} // prop from child of Accordion
          >
            {React.cloneElement(child, { onRerender: () => setTimeout(onRerender, 170) })}
          </SubAccordion>
        )
      })
    }
  }))
);


// WEBPACK FOOTER //
// ./src/components/accordions/withAccordion.js